var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialFacebook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.033,
    height: 20,
    viewBox: "0 0 10.033 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social_facebook",
    transform: "translate(-8.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M10.546,20h3.748l0-10h3.4l.365-3.446H14.293l0-1.725c0-.9.061-1.38,1.351-1.38h2.382V0H14.616C11.3,0,10.542,1.711,10.542,4.523l0,2.03H8.032V10h2.514Z",
    fill: "#047BC1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-facebook.897c437c670d5a6def60a388dd74a819.svg";